import React from "react";
import "../../styles/Player.css";
function ProgressBar({ value, onChange, onMouseUp, onTouchEnd }) {
  return (
    <div className="w-full">
      <input
        type="range"
        name=""
        id=""
        className="h-[4px] bg-slate-200/30 slider w-full"
        min={1}
        max={100}
        step={1}
        value={value}
        onChange={onChange}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
        style={{
          background: `linear-gradient(90deg, var(--blue) ${Math.floor(
            value
          )}%, rgb(226 232 240 / 0.1)  ${Math.floor(value)}%)`,
        }}
      />
    </div>
  );
}

export default ProgressBar;
